import React from 'react'

export default function ChatTime({ updatedAt, formatDate }) {
  return (
    <p className="chat-time mb-0">
      <i className="ri-time-line align-middle"></i>{" "}
      <span className="align-middle">{formatDate(new Date(updatedAt))}</span>
    </p>
  )
}
